import React,{useEffect,useState} from "react";
import {Link} from 'react-router-dom'
import jsPDF from 'jspdf';
import 'jspdf-autotable'
import * as XLSX from 'xlsx/xlsx.mjs';
import { Oval } from  'react-loader-spinner'
import _ from 'lodash'


const TcWinnermain = () => {
  
  const[today, setToday] =useState([])
  const[date, setDate] =useState([])
  
  const[yesterday,setYesterday] = useState([])
  
  const[weekly,setWeekly] = useState([])
 
  const[pop,setpop] = useState(false);
  const [allusers,setAllusers]= useState([])
    const [currentPage, setcurrentPage] = useState(1);
     

  useEffect(()=>{
   
    GetTodayWinner();
    GetYesterdayWinner();
    GetWeeklyWinner();
    document.getElementById('TCwinnertable').style.display = "none";
    document.getElementById('TCwinnerHidetable').style.display = "none";

    document.getElementById('TCyesterdaywinnertable').style.display = "none";
    document.getElementById('TCyesterdayHidetable').style.display = "none";

    document.getElementById('TCweeklywinnertable').style.display = "none";
    document.getElementById('TCweeklyHidetable').style.display = "none";

     document.getElementById('Tc-winnerbtn').style.display = "none";
     document.getElementById('Tc-yesterdaywinnerbtn').style.display = "none";
     document.getElementById('Tc-weeklywinnerbtn').style.display = "none";
   
  },[])

  /*--- Today table---*/

  function displaytable(){
    setpop(true);
   
    document.getElementById('TCyesterdaywinnertable').style.display = "none";
      document.getElementById('Tc-yesterdaywinnerbtn').style.display = "none";
      document.getElementById('TCweeklywinnertable').style.display = "none";
      document.getElementById('Tc-weeklywinnerbtn').style.display = "none";
      document.getElementById('TCwinnertable').style.display = "none";
      document.getElementById('Tc-winnerbtn').style.display = "none";
      document.getElementById('tdywinner_btn').style.background= "linear-gradient( #fe9347, #ff6a00)"
      document.getElementById('weeklywinner_btn').style.background = "linear-gradient( #fe9347, #ff6a00)"
      document.getElementById('ytdwinner_btn').style.background = "linear-gradient( #fe9347, #ff6a00)"

    setTimeout(()=>{
      setpop(false);
    
      document.getElementById('TCwinnertable').style.display = "flex";
      document.getElementById('Tc-winnerbtn').style.display = "flex";
      document.getElementById('tdywinner_btn').style.background= "rgb(19, 58, 98)"
      document.getElementById('weeklywinner_btn').style.background = "linear-gradient( #fe9347, #ff6a00)"
      document.getElementById('ytdwinner_btn').style.background = "linear-gradient( #fe9347, #ff6a00)"

      document.getElementById('TCyesterdaywinnertable').style.display = "none";
      document.getElementById('Tc-yesterdaywinnerbtn').style.display = "none";
      document.getElementById('TCweeklywinnertable').style.display = "none";
      document.getElementById('Tc-weeklywinnerbtn').style.display = "none";
    },1000)
   
  }
  
/*--- Yesterday table---*/

function displayyesterdaywinner(){
  setpop(true);
  document.getElementById('TCwinnertable').style.display = "none";
  document.getElementById('Tc-winnerbtn').style.display = "none";
 
  document.getElementById('TCweeklywinnertable').style.display = "none";
  document.getElementById('Tc-weeklywinnerbtn').style.display = "none";
  document.getElementById('TCyesterdaywinnertable').style.display = "none";
  document.getElementById('Tc-yesterdaywinnerbtn').style.display = "none";
 
  document.getElementById('tdywinner_btn').style.background= "linear-gradient( #fe9347, #ff6a00)"
  document.getElementById('weeklywinner_btn').style.background = "linear-gradient( #fe9347, #ff6a00)"
  document.getElementById('ytdwinner_btn').style.background = "linear-gradient( #fe9347, #ff6a00)"
    setTimeout(()=>{
      setpop(false);
      {}
  document.getElementById('TCyesterdaywinnertable').style.display = "flex";
  document.getElementById('Tc-yesterdaywinnerbtn').style.display = "flex";
  document.getElementById('ytdwinner_btn').style.background= "rgb(19, 58, 98)"
  document.getElementById('tdywinner_btn').style.background = "linear-gradient( #fe9347, #ff6a00)"
  document.getElementById('weeklywinner_btn').style.background = "linear-gradient( #fe9347, #ff6a00)"

  document.getElementById('TCwinnertable').style.display = "none";
  document.getElementById('Tc-winnerbtn').style.display = "none";
 
  document.getElementById('TCweeklywinnertable').style.display = "none";
  document.getElementById('Tc-weeklywinnerbtn').style.display = "none";
},1000)
}

/*--- Weekly winner table---*/

function displayweeklywinner(){
  setpop(true);
  document.getElementById('TCwinnertable').style.display = "none";
  document.getElementById('Tc-winnerbtn').style.display = "none";
  document.getElementById('TCyesterdaywinnertable').style.display = "none";
  document.getElementById('Tc-yesterdaywinnerbtn').style.display = "none";
  document.getElementById('TCweeklywinnertable').style.display = "none";
  document.getElementById('Tc-weeklywinnerbtn').style.display = "none";

  document.getElementById('tdywinner_btn').style.background= "linear-gradient( #fe9347, #ff6a00)"
  document.getElementById('weeklywinner_btn').style.background = "linear-gradient( #fe9347, #ff6a00)"
  document.getElementById('ytdwinner_btn').style.background = "linear-gradient( #fe9347, #ff6a00)"

  setTimeout(()=>{
    setpop(false);
  document.getElementById('TCweeklywinnertable').style.display = "flex";
  document.getElementById('Tc-weeklywinnerbtn').style.display = "flex"; 
  document.getElementById('weeklywinner_btn').style.background= "rgb(19, 58, 98)"
  document.getElementById('ytdwinner_btn').style.background= "linear-gradient( #fe9347, #ff6a00)"
  document.getElementById('tdywinner_btn').style.background= "linear-gradient( #fe9347, #ff6a00)"
  document.getElementById('TCwinnertable').style.display = "none";
  document.getElementById('Tc-winnerbtn').style.display = "none";
  document.getElementById('TCyesterdaywinnertable').style.display = "none";
  document.getElementById('Tc-yesterdaywinnerbtn').style.display = "none";
},1000)

}

/*--- Today Get Methods---*/

  function GetTodayWinner(){
     
    fetch('https://tclapi.thatscool.in/api/Winner/winnertodayapp', {
     
    method:'GET',
  
      headers : {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
  

}).then(response => response.json())
.then(data => {
console.log("Data",data)
setToday(data)

});

}

/*--- Yesterday Get Methods---*/

function GetYesterdayWinner(){
     
  fetch('https://tclapi.thatscool.in/api/Winner/winneryesterday', {
   
  method:'GET',

    headers : {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    },


}).then(response => response.json())
.then(data => {
console.log("Data",data)
setYesterday(data)


});

}

/*--- Weekly Get Methods---*/

function GetWeeklyWinner(){
     
  fetch('https://tclapi.thatscool.in/api/Winner/winnerweekly', {
   
  method:'GET',

    headers : {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    },


}).then(response => response.json())
.then(data => {
console.log("Data",data)
setAllusers(data)
setWeekly(data)

});

}

/*--- Today download btn---*/

  function downloadPdf(){
   
 var pdf = new jsPDF();

 pdf.autoTable({html:'#tdywinner'});

 pdf.save('todayTable.pdf');

}

function downloadExcel(){

  var table = document.getElementById("tdywinner"); 

  var workbook = XLSX.utils.table_to_book(table);
   
  XLSX.writeFile(workbook, "todayTable.xlsx");

  console.log(workbook);
    
 }

 /*--- Yesterday download btn---*/

 function downloadyesterdaywinnerpdf(){
   
  var pdf = new jsPDF();
  
  pdf.autoTable({html:'#yesterdayWinner'});

  pdf.save('yesterdayTable.pdf');
 
 }
 
 function downloadyesterdaywinnerExcel(){
 
   var table = document.getElementById("yesterdayWinner"); 
  
   var workbook = XLSX.utils.table_to_book(table);
    
   XLSX.writeFile(workbook, "yesterdayTable.xlsx");
 
   console.log(workbook);
     
  }

   /*--- Weekly winner download btn---*/


 
 function downloadweeklywinnerpdf(){

   
  var pdf = new jsPDF();
  
  pdf.autoTable({html:'#weeklyWinner'});
 
  pdf.save('weeklyTable.pdf');
 
 }
 
 function downloadweeklywinnerExcel(){
 
   var table = document.getElementById("weeklyWinner"); 
  
   var workbook = XLSX.utils.table_to_book(table);
    
   XLSX.writeFile(workbook, "WeeklyTable.xlsx");
 
   console.log(workbook);
     
  }

  

return(
    <>
 
        <div className='TC-addmain'>   
    <div className="TC-addgrid-layout">
  <div className="TC-addmain-top">
  <div className='TC-addmain-back'>
    <Link to='/Tcsection'><i className="fa-sharp fa-solid fa-backward"></i></Link>
    </div> 
    <span> Winner </span>
    </div>
    </div>

    <div className='Tc-TransactionMain' id='Tc-sectionMain'>
      <button  className="winnerBtn" id="tdywinner_btn" onClick={displaytable}>Today</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button className="winnerBtn"  id="ytdwinner_btn"onClick={displayyesterdaywinner}>Yesterday</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button  className="winnerBtn" id="weeklywinner_btn" onClick={ displayweeklywinner}>Weekly</button>
    </div>

    
    {/* ----Today Table----- */}

 <div className='TCtable' id='TCwinnertable'>
     <div className="TC-table_responsive">
     {today.length==0?<span id="winnerSpan">No Data</span>: <table  className='TC-tblhead' id='TcTable'> 
    <thead>
   <tr>
<th>Created_Date</th>
<th>Profile_Name</th>
<th>Profile_ImagePath</th>
<th>Rank_No</th>
</tr>
</thead>
<tbody>
{today.map((e)=>
{
 
return<tr>
<td>{e.Created_Date.slice(0,10)}</td>

<td>{e.profile_name}</td>

<td><img src={e.profile_imagePath}></img></td>
<td>{e.Rank_No}</td>
</tr>
}
)} 
</tbody>

</table>}

     </div>
  </div>

  <div className='TCtable' id='TCwinnerHidetable'>
     <div class="TC-table_responsive">
    <table  className='TC-tblhead' id='tdywinner'> 
    <thead>
   <tr>
<th>Created_Date</th>
<th>Profile_Name</th>
<th>Profile_ImagePath</th>
<th>Rank_No</th>
</tr>
</thead>
<tbody>
{today.map((e)=>
{
 
return<tr>
<td>{e.Created_Date.slice(0,10)}</td>

<td>{e.profile_name}</td>

<td>{e.profile_imagePath.slice(50)}</td>
<td>{e.Rank_No}</td>
</tr>
}
)} 
</tbody>

</table>

     </div>
  </div>

 <div className='Tc-TransactionMain' id='Tc-winnerbtn'>
 {today.length ==0?null:<button id='TCdownloadbtn' onClick={downloadPdf}>Download as PDF</button>}  &nbsp; &nbsp;&nbsp; &nbsp;
 {today.length ==0?null:<button id='TCdownloadbtn'onClick={downloadExcel} >Download as Excel</button>}
     </div>


   {/* ----Yesterday Table----- */}

  <div className='TCtable' id='TCyesterdaywinnertable'>
     <div class="TC-table_responsive">
      
      {yesterday.length==0?<span id="winnerSpan">No Data</span>:<table  className='TC-tblhead' id='yesterday'> 
    <thead>
   <tr>
<th>Created_Date</th>
<th>Profile_Name</th>
<th>Profile_ImagePath</th>
<th>Rank_No</th>
</tr>
</thead>
<tbody>
{yesterday.map((e)=>
{
 
return<tr>
  
<td>{e.Created_Date.slice(0,10)}</td>

<td>{e.profile_name}</td>

<td><img src={e.profile_imagePath}></img></td>
<td>{e.Rank_No}</td>
</tr>
}
)}
</tbody>

</table>}

<div className='TCtable' id='TCyesterdayHidetable'>
     <div class="TC-table_responsive"> 
     <table  className='TC-tblhead' id='yesterdayWinner'> 
    <thead>
   <tr>
<th>Created_Date</th>
<th>Profile_Name</th>
<th>Profile_ImagePath</th>
<th>Rank_No</th>
</tr>
</thead>
<tbody>
{yesterday.map((e)=>
{
 
return<tr>
  
<td>{e.Created_Date.slice(0,10)}</td>

<td>{e.profile_name}</td>

<td>{e.profile_imagePath.slice(50)}</td>
<td>{e.Rank_No}</td>
</tr>
}
)}
</tbody>

</table>
</div>
  </div>

     </div>
  </div>
  <div className='Tc-TransactionMain' id='Tc-yesterdaywinnerbtn'>
  {yesterday.length==0?null: <button id='TCdownloadbtn' onClick={downloadyesterdaywinnerpdf}>Download as PDF</button>}  &nbsp; &nbsp;&nbsp; &nbsp;
    {yesterday.length==0?null:  <button id='TCdownloadbtn'onClick={downloadyesterdaywinnerExcel} >Download as Excel</button>} 
     </div>


   {/* ----Weekly Table----- */}

   <div className='TCtable' id='TCweeklywinnertable'>
   <div class="TC-table_responsive">
     
    {weekly.length==0?<span id="winnerSpan">No Data</span>:   <table  className='TC-tblhead' id='weekly'> 
    <thead>
   <tr>
 
<th>Created_Date</th>
<th>Profile_Name</th>
<th>Profile_ImagePath</th>
<th>Rank_No</th>
</tr>
</thead>
<tbody>
{weekly.map((e)=>
{
 
return<tr>
  
<td>{e.Created_Date.slice(0,10)}</td>

<td>{e.profile_name}</td>

<td id="picture"><img src={e.profile_imagePath}></img></td>
<td>{e.Rank_No}</td>
</tr>
}
)}
</tbody>

</table>
}



<div className='TCtable' id='TCweeklyHidetable'>
   <div class="TC-table_responsive">
 
     <table  className='TC-tblhead' id='weeklyWinner'> 
    <thead>
   <tr>
 
<th>Created_Date</th>
<th>Profile_Name</th>
<th>Profile_ImagePath</th>
<th>Rank_No</th>
</tr>
</thead>
<tbody>
{weekly.map((e)=>
{
 
return<tr>
  
<td>{e.Created_Date.slice(0,10)}</td>

<td>{e.profile_name}</td>

<td id="picture">{e.profile_imagePath.slice(50)}</td>
<td>{e.Rank_No}</td>
</tr>
}
)}
</tbody>

</table>
 
   </div>
  </div>

     </div>
  </div>
 
  <div className='Tc-TransactionMain' id='Tc-weeklywinnerbtn'>
  {weekly.length==0?null: <button id='TCdownloadbtn' onClick={downloadweeklywinnerpdf}>Download as PDF</button>}  &nbsp; &nbsp;&nbsp; &nbsp;
     {weekly.length==0?null:  <button id='TCdownloadbtn'onClick={downloadweeklywinnerExcel} >Download as Excel</button> }
     </div>

     {pop? <div id="Loader">
<Oval
  height={40}
  width={50}
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}
    
    </div>

    </>
)
}

export default TcWinnermain;